<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Configurar Vehiculo&nbsp
              |
              a.button.is-black.is-rounded(@click="backToPage")
                i.fas.fa-times  
        .columns
          .column.is-12
            FormVehiculo(:vehiculos="vehiculos" @saveForm="saveForm" @updateForm="updateForm")
        .columns.column-blanco
</template>

<script>
  import NavBar from './layout/NavBarTransportes.vue'
  import FormVehiculo from './componentes/FormVehiculo.vue'
  import Loader from '@/components/shared/Loader.vue'
  
  import InventarioServices from '@/services/inventario/inventario'
  import moment from 'moment'
  import { mapState } from 'vuex'
  
  export default {
    name: 'NuevoVehiculo',
    components: { NavBar, Loader, FormVehiculo },
    data() {
      return {
        isLoading: true,
        vehiculos: []
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerVehiculos()
      },
      obtenerVehiculos() {
        InventarioServices.getVehiculosData()
          .then((data) => {
            this.vehiculos = data.map(this.convetirData)
          })
          .catch((e) => console.log(e))
          this.isLoading = false
      },
      saveForm (dataForm) {
        console.log(dataForm)
        InventarioServices.addVehiculoData(dataForm.id_articulo, dataForm.placas, dataForm.proximoServicio, 
        dataForm.verificacion, dataForm.tipo, dataForm.modelo, dataForm.anio, dataForm.tipoVerificacion)
          .then((data) => {
            console.log(data)
            if (data.success) {
              this.displayToast(data.respuesta, 'Ok', '/Transportes/Vehiculos', 'done')
              this.$router.push('/Transportes/Vehiculos')
            } else {
              this.displayToast(data.respuesta, 'Ok', '', 'ban')
            }
          })
          .catch((e) => console.log(e))
      },
      updateForm(dataForm) {
        console.log(dataForm)
        InventarioServices.updateVehiculoData(dataForm.id, dataForm.servicio, dataForm.verificacion, 
        dataForm.year, dataForm.tipoVerificacion)
          .then((data) => {
            console.log(data)
            if (data.success) {
              this.displayToast(data.respuesta, 'Ok', '/Transportes/Vehiculos', 'done')
              this.$router.push('/Transportes/Vehiculos')
            } else {
              this.displayToast(data.respuesta, 'Ok', '', 'ban')
            }
          })
          .catch((e) => console.log(e))
      },
      
      convetirData(v) {
        return {
          ...v,
          anio: parseInt(v.anio),
          estatus: parseInt(v.estatus),
          id: parseInt(v.id),
          proximoServicio: Number(v.estatus),
        }
      },
      
      displayToast(texto, textTag, destino, icon) {
        let toast = this.$toasted.show(texto, { 
          theme: "toasted-primary", 
          position: "bottom-right", 
          duration : 5000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : textTag,
            onClick : (e, toastObject) => {
              this.$router.push(destino)
              toastObject.goAway(0)
            }
          },
        })
      },
      backToPage () {
        this.$router.back()
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['logueado', 'userLogin'])
    }
  }
</script>

<style lang="css" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/NuevoVehiculo.vue